import styled from 'styled-components';

import ActionButton from 'components/action-button';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

export const Description = styled(SanityBlockRenderer)`
  p {
    font-family: ${Styles.fontFamily.body};
    color: ${primitive.th.$coffeeBrown};
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  margin: 0;
  margin-right: ${primitive.$spacing10};
  padding-bottom: 14px;
`;

export const AddNewPaymentButton = styled(ActionButton)`
  width: 50%;
  font-size: 0.875rem;
  padding: 9px 12px;
`;
